<template>
	<v-container>
		<v-layout align-center justify-center class="dataLoading">
			<v-progress-circular
				indeterminate
				color="primary"
				v-show="loading"
			/>
		</v-layout>
		<v-file-input
			label="Select your excel file"
			chips
			show-size
			counter
			filled
			prepend-icon="mdi-file-find-outline"
			v-model="chosenFile"
		/>
		<v-btn
			right
			:disabled="buttonDisabled && !loading"
			@click="importFile"
		>
			{{ txt.readFile }}
		</v-btn>
	</v-container>
</template>

<script>
import * as XLSX from 'xlsx'
import axios from 'axios'

export default {
	name: 'UbsXmlExport',
	data() {
		return {
			txt: {
				readFile: 'Process file',
			},
			chosenFile: null,
			data: null,
			buttonDisabled: true,
			loading: false,
		}
	},
	methods: {
		importFile() {
			if (!this.chosenFile) { this.data = '' }
			const reader = new FileReader()
			// Use the javascript reader object to load the contents
			// of the file in the v-model prop
			reader.onload = async (e) => {
				/* Parse data */
				try {
					this.loading = true
					const bstr = e.target.result
					const wb = XLSX.read(bstr, { type: 'binary', /* cellDates: true, dateNF: 'dd/mm/yy', cellNF: false, cellText: false */ })
					/* Get first worksheet */
					const wsname = wb.SheetNames[0]
					const ws = wb.Sheets[wsname]
					/* Convert array of arrays */
					this.data = XLSX.utils.sheet_to_json(ws, { header: 1, raw: false })
					const res = await axios.post(`${config.baseAPIurl}/ubs-xml-export/parse-excel`, { excelContents: this.data })
					saveAs(new Blob([res.data]), `ubs_export_${new Date().toDateString()}.xml`)
					/* this.data = res.data */
				} catch (error) {
					console.log(error)
				} finally {
					this.loading = false
				}
			}

			reader.readAsBinaryString(this.chosenFile)
		},
	},
	watch: {
		chosenFile: {
			handler() {
				this.data = null
				this.buttonDisabled = !(this.chosenFile)
			},
		},
	},
}

</script>

<style scoped>
.dataLoading {
	padding-top: 11px;
}
</style>
